import { TypographyOptions } from '@mui/material/styles/createTypography';

import { tokens } from './tokens';

/**
 * Dense back-office type scale (Inter, same family as before). The PALO look
 * comes from the tighter sizes/weights, not a different font.
 */
export const typography: TypographyOptions = {
    fontFamily: tokens.font.sans,
    htmlFontSize: 16,
    fontSize: 13,
    h1: { fontSize: '1.75rem', fontWeight: 600, lineHeight: 1.2, letterSpacing: '-0.01em' },
    h2: { fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.25, letterSpacing: '-0.01em' },
    h3: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: '1.0625rem', fontWeight: 600, lineHeight: 1.35 },
    h5: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.4 },
    subtitle1: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.45 },
    subtitle2: { fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.5 },
    body1: { fontSize: '0.8125rem', fontWeight: 400, lineHeight: 1.45 }, // 13px
    body2: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.5 }, // 12px
    button: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.4, textTransform: 'none', letterSpacing: 0 },
    caption: { fontSize: '0.6875rem', fontWeight: 400, lineHeight: 1.5 }, // 11px
    overline: { fontSize: '0.625rem', fontWeight: 600, lineHeight: 1.5, textTransform: 'uppercase', letterSpacing: '0.06em' },
};
